<template>
  <div id="payment-success-page">
    <AppHero :heading="'Your purchase was completed Successfully'">
      <p class="body-copy body-copy--align-center">
        You can now continue with using the tool
      </p>
    </AppHero>

    <section class="chosen-plan">
      <div class="container container--mw-xxl">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-8 col-xl-6">
            <TextBlock
              v-if="activePlan === 'Khonsu Single Session'"
              :heading="'Khonsu Single Session'"
              :button-text="'Go to Account'"
              :button-link="'/my-account'"
            >
              <p class="body-copy body-copy--align-center">
                You just need us for a one-off exercise, whether that’s to help
                you with name generation or whether you want to run a basic
                clearance search. Our Khonsu Single Session will give you 5
                searches on all of our tools.
              </p>
            </TextBlock>

            <TextBlock
              v-if="activePlan === 'Khonsu Light'"
              :heading="'Khonsu Light'"
              :button-text="'Go to Account'"
              :button-link="'/my-account'"
            >
              <p class="body-copy body-copy--align-center">
                If from time to time you get involved in name generation or if
                you’re working on a project and just need an extra pair of hands
                then our Khonsu Light option is for you. You start with 15
                searches or World Builds and if this isn’t enough, just keep
                topping up until you’re done.
              </p>
            </TextBlock>

            <TextBlock
              v-if="activePlan === 'Khonsu Unlimited'"
              :heading="'Khonsu Unlimited'"
              :button-text="'Go to Account'"
              :button-link="'/my-account'"
            >
              <p class="body-copy body-copy--align-center">
                You’re a frequent user, typically a company who regularly
                require new names or need to conduct basic brand clearance
                (consisting of web and social media searches together with a
                basic trademark search of the UK and European trademark
                offices). We’ll charge you for your first month of Khonsu usage
                and continue to charge you on a monthly basis until you tell us
                otherwise.
              </p>
            </TextBlock>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AppHero from "@/components/layout/AppHero";
import TextBlock from "@/components/blocks/TextBlock";
import axios from "axios";
export default {
  name: "PaymentSuccessPage",
  metaInfo: {
    title: "Khonsu - PaymentSuccessPage",
  },
  components: {
    AppHero,
    TextBlock,
  },
  data() {
    return {
      amount: null,
      khonsu_unlimited_date: new Date(
        new Date().setDate(new Date().getDate() + 30)
      ),
      activePlan: null,
    };
  },
  methods: {
    fetchActivePlan() {
      const userId = sessionStorage.getItem("user_id");
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_ROOT_URL}/api/getactiveplan`,
        data: {
          userId,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (
            response.data.activePlan !== undefined &&
            response.data.activePlan.length > 0
          ) {
            this.activePlan = response.data.activePlan;
          } else {
            this.activePlan = "No Active Plan";
          }
        })
        .catch((error) => {
          this.activePlan = "No Active Plan";
          console.error(error);
        });
    },
  },
  mounted() {
    this.amount = this.$route.params.amount;
    this.fetchActivePlan(); // Call fetchActivePlan to get the active plan.
  },
};
</script>
